import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(() => ({
        submitButton: {
            // override global registration margins
            marginTop: "0 !important"
        }
}));